module.exports = __webpack_public_path__ + "static/media/favicon.18932a94.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/favicon.png
// module id = 58
// module chunks = 0